// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Roboto', 'Inter', system-ui, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #0a0a0a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* Parallax Sections */
.parallax-section {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;
}

.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4));
  z-index: 1;
}

.parallax-content {
  position: relative;
  z-index: 2;
  max-width: 60%;
  padding: 2rem;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-blur-transition {
  animation: fadeIn 1.2s ease-out;
}

/* Typography */
.section-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.section-subtitle {
  font-size: 1.5rem;
  font-weight: 300;
  margin-bottom: 1rem;
  color: #e0e0e0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.section-description {
  font-size: 1.125rem;
  line-height: 1.8;
  color: #d0d0d0;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  margin-top: 1.5rem;
  text-align: justify;
  text-shadow: 2px 2px 8px rgba(0,0,0,0.8);
}

/* Color Classes */
.text-primary {
  color: #fff;
}

.text-secondary {
  color: #fff;
}

.text-accent {
  color: #fff;
}

.bg-gradient-primary {
  color: #fff;
}

/* Navbar Styles */
.navbar-glass {
  background: transparent;
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - 16px);
  /* Corrige para não sobrepor a barra de scroll */
  z-index: 50;
}

.navbar-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem 1.5rem;
  position: relative; /* ADICIONADO: permite posicionamento absoluto do switch */
}

.navbar-content ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-link {
  color: #d0d0d0;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  font-size: 0.95rem;
}

.nav-link:hover {
  color: #00ff88;
  transform: translateY(-2px);
  text-shadow: 0 4px 8px rgba(0, 255, 136, 0.3);
}

.nav-link.active {
  color: #00ff88;
  transform: scale(1.1);
  font-weight: 600;
}

.navbar-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  left: 1rem;
  top: 1rem;
  z-index: 100;
}

.navbar-hamburger {
  display: block;
  width: 28px;
  height: 3px;
  background: #d0d0d0;
  position: relative;
}

.navbar-hamburger::before,
.navbar-hamburger::after {
  content: '';
  display: block;
  width: 28px;
  height: 3px;
  background: #d0d0d0;
  position: absolute;
  left: 0;
  transition: 0.3s;
}

.navbar-hamburger::before {
  top: -8px;
}

.navbar-hamburger::after {
  top: 8px;
}

.lang-switch {
  position: absolute;
  right: -10rem;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  gap: 0.25rem;
  background: rgba(255,255,255,0.04);
  border-radius: 999px;
  padding: 0.15rem;
  border: 1px solid rgba(255,255,255,0.06);
  z-index: 101;
}

.lang-option {
  background: transparent;
  color: #d0d0d0;
  border: none;
  padding: 0.35rem 0.6rem;
  border-radius: 0.65rem;
  font-weight: 700;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background 160ms ease, color 160ms ease, transform 120ms ease;
}

.lang-option:hover {
  background: rgba(255,255,255,0.06);
  transform: translateY(-1px);
}

/* active state highlight */
.lang-option.active {
  background: linear-gradient(90deg, #00ff88 0%, #24d18b 100%);
  color: #062017;
  box-shadow: 0 6px 18px rgba(0,255,136,0.12);
}

/* mobile override: keep switch visible and compact */
@media (max-width: 768px) {
  .lang-switch {
    right: 1rem;
    top: 0.9rem;
    transform: none;
    padding: 0.1rem;
  }
  .lang-option {
    padding: 0.28rem 0.5rem;
    font-size: 0.8rem;
  }
}

/* Utility Classes */
.relative {
  position: relative;
}

.fixed {
  position: fixed;
}

.pt-20 {
  padding-top: 5rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.justify-center {
  justify-content: center;
}

.items-center {
  align-items: center;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-8 {
  gap: 2rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(30px);
    filter: blur(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
    filter: blur(0);
  }
}

@keyframes float {

  0%,
  100% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes glow {

  0%,
  100% {
    filter: drop-shadow(0 0 5px currentColor);
  }

  50% {
    filter: drop-shadow(0 0 20px currentColor);
  }
}

.float-animation {
  animation: float 3s ease-in-out infinite;
}

.glow-animation {
  animation: glow 2s ease-in-out infinite;
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-title {
    font-size: 2.5rem;
  }

  .section-subtitle {
    font-size: 1.25rem;
  }

  .section-description {
    font-size: 1rem;
  }

  .navbar-content {
    gap: 1rem;
  }

  .nav-link {
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
  }

  .container {
    padding: 0 1rem;
  }

  .navbar-toggle {
    display: block;
  }

  .navbar-list {
    display: none !important;
    flex-direction: column;
    gap: 1rem;
    background: rgba(30, 30, 30, 0.80);
    backdrop-filter: blur(12px) saturate(160%);
    -webkit-backdrop-filter: blur(12px) saturate(160%);
    position: absolute;
    top: 0; 
    left: 0;
    width: 100vw;
    height: auto;
    max-height: 80vh;  
    overflow-y: auto;
    padding: 4rem 0 1.5rem 0; 
    border-radius: 0 0 10px 10px;
    z-index: 99;
  }

  .navbar-list.open {
    display: flex !important;
  }

  .parallax-content {

    max-width: 100%;

  }
}`, "",{"version":3,"sources":["webpack://./src/components/infoPage/infoPage.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,kDAAkD;EAClD,kDAAkD;EAClD,eAAe;EACf,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kBAAkB,EAAE,0DAA0D;AAChF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,4DAA4D;EAC5D,cAAc;EACd,2CAA2C;AAC7C;;AAEA,qDAAqD;AACrD;EACE;IACE,WAAW;IACX,WAAW;IACX,eAAe;IACf,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,eAAe;EACjB;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;;EAEE;;IAEE,yCAAyC;EAC3C;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,SAAS;IACT,kCAAkC;IAClC,0CAA0C;IAC1C,kDAAkD;IAClD,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,eAAe;;EAEjB;AACF","sourcesContent":["/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: 'Roboto', 'Inter', system-ui, sans-serif;\n  line-height: 1.6;\n  color: #333;\n  background-color: #0a0a0a;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 1.5rem;\n}\n\n/* Parallax Sections */\n.parallax-section {\n  min-height: 100vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  overflow: hidden;\n}\n\n.parallax-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.4));\n  z-index: 1;\n}\n\n.parallax-content {\n  position: relative;\n  z-index: 2;\n  max-width: 60%;\n  padding: 2rem;\n  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.fade-blur-transition {\n  animation: fadeIn 1.2s ease-out;\n}\n\n/* Typography */\n.section-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  line-height: 1.2;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.section-subtitle {\n  font-size: 1.5rem;\n  font-weight: 300;\n  margin-bottom: 1rem;\n  color: #e0e0e0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.section-description {\n  font-size: 1.125rem;\n  line-height: 1.8;\n  color: #d0d0d0;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  margin-top: 1.5rem;\n  text-align: justify;\n  text-shadow: 2px 2px 8px rgba(0,0,0,0.8);\n}\n\n/* Color Classes */\n.text-primary {\n  color: #fff;\n}\n\n.text-secondary {\n  color: #fff;\n}\n\n.text-accent {\n  color: #fff;\n}\n\n.bg-gradient-primary {\n  color: #fff;\n}\n\n/* Navbar Styles */\n.navbar-glass {\n  background: transparent;\n  backdrop-filter: blur(16px) saturate(180%);\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: calc(100vw - 16px);\n  /* Corrige para não sobrepor a barra de scroll */\n  z-index: 50;\n}\n\n.navbar-content {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem 1.5rem;\n  position: relative; /* ADICIONADO: permite posicionamento absoluto do switch */\n}\n\n.navbar-content ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.nav-link {\n  color: #d0d0d0;\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  font-size: 0.95rem;\n}\n\n.nav-link:hover {\n  color: #00ff88;\n  transform: translateY(-2px);\n  text-shadow: 0 4px 8px rgba(0, 255, 136, 0.3);\n}\n\n.nav-link.active {\n  color: #00ff88;\n  transform: scale(1.1);\n  font-weight: 600;\n}\n\n.navbar-toggle {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  position: absolute;\n  left: 1rem;\n  top: 1rem;\n  z-index: 100;\n}\n\n.navbar-hamburger {\n  display: block;\n  width: 28px;\n  height: 3px;\n  background: #d0d0d0;\n  position: relative;\n}\n\n.navbar-hamburger::before,\n.navbar-hamburger::after {\n  content: '';\n  display: block;\n  width: 28px;\n  height: 3px;\n  background: #d0d0d0;\n  position: absolute;\n  left: 0;\n  transition: 0.3s;\n}\n\n.navbar-hamburger::before {\n  top: -8px;\n}\n\n.navbar-hamburger::after {\n  top: 8px;\n}\n\n.lang-switch {\n  position: absolute;\n  right: -10rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n  gap: 0.25rem;\n  background: rgba(255,255,255,0.04);\n  border-radius: 999px;\n  padding: 0.15rem;\n  border: 1px solid rgba(255,255,255,0.06);\n  z-index: 101;\n}\n\n.lang-option {\n  background: transparent;\n  color: #d0d0d0;\n  border: none;\n  padding: 0.35rem 0.6rem;\n  border-radius: 0.65rem;\n  font-weight: 700;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: background 160ms ease, color 160ms ease, transform 120ms ease;\n}\n\n.lang-option:hover {\n  background: rgba(255,255,255,0.06);\n  transform: translateY(-1px);\n}\n\n/* active state highlight */\n.lang-option.active {\n  background: linear-gradient(90deg, #00ff88 0%, #24d18b 100%);\n  color: #062017;\n  box-shadow: 0 6px 18px rgba(0,255,136,0.12);\n}\n\n/* mobile override: keep switch visible and compact */\n@media (max-width: 768px) {\n  .lang-switch {\n    right: 1rem;\n    top: 0.9rem;\n    transform: none;\n    padding: 0.1rem;\n  }\n  .lang-option {\n    padding: 0.28rem 0.5rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Utility Classes */\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.pt-20 {\n  padding-top: 5rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.gap-6 {\n  gap: 1.5rem;\n}\n\n.gap-8 {\n  gap: 2rem;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n    filter: blur(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n    filter: blur(0);\n  }\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translateY(0px);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@keyframes glow {\n\n  0%,\n  100% {\n    filter: drop-shadow(0 0 5px currentColor);\n  }\n\n  50% {\n    filter: drop-shadow(0 0 20px currentColor);\n  }\n}\n\n.float-animation {\n  animation: float 3s ease-in-out infinite;\n}\n\n.glow-animation {\n  animation: glow 2s ease-in-out infinite;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .section-title {\n    font-size: 2.5rem;\n  }\n\n  .section-subtitle {\n    font-size: 1.25rem;\n  }\n\n  .section-description {\n    font-size: 1rem;\n  }\n\n  .navbar-content {\n    gap: 1rem;\n  }\n\n  .nav-link {\n    font-size: 0.875rem;\n    padding: 0.375rem 0.75rem;\n  }\n\n  .container {\n    padding: 0 1rem;\n  }\n\n  .navbar-toggle {\n    display: block;\n  }\n\n  .navbar-list {\n    display: none !important;\n    flex-direction: column;\n    gap: 1rem;\n    background: rgba(30, 30, 30, 0.80);\n    backdrop-filter: blur(12px) saturate(160%);\n    -webkit-backdrop-filter: blur(12px) saturate(160%);\n    position: absolute;\n    top: 0; \n    left: 0;\n    width: 100vw;\n    height: auto;\n    max-height: 80vh;  \n    overflow-y: auto;\n    padding: 4rem 0 1.5rem 0; \n    border-radius: 0 0 10px 10px;\n    z-index: 99;\n  }\n\n  .navbar-list.open {\n    display: flex !important;\n  }\n\n  .parallax-content {\n\n    max-width: 100%;\n\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
